export enum BadgeTypes {
  form = 'Form',
  course = 'Course',
  module = 'Module',
}

export default BadgeTypes;
